import {Component, OnInit} from '@angular/core';
import {
    IonButton,
    IonButtons, IonCol,
    IonGrid,
    IonHeader,
    IonIcon,
    IonRow,
    IonSelect,
    IonSelectOption,
    IonTitle,
    IonToolbar
} from '@ionic/angular/standalone';
import {environment} from '../../../../environments/environment';
import {TranslatePipe} from '@ngx-translate/core';
import {LanguageService} from '../../../services/language/language.service';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css'],
    imports: [IonHeader, IonTitle, IonToolbar, IonButton, IonButtons, IonIcon, IonGrid, IonRow, IonCol, IonSelect, IonSelectOption, TranslatePipe],
    standalone: true,
})
export class HeaderComponent implements OnInit {

    constructor(public languageService: LanguageService) {
    }

    ngOnInit() {
    }

    public navigateToClickkerCloud() {
        window.open(environment.clickkerCloud.mvc.url, "_blank");
    }
}
